import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Sparkles, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { HEROES } from '../data/heroes';
import HeroNarrateButton from './HeroNarrateButton';

const DAILY_MANTRAS = {
  queen: {
    en: 'You are enough. You matter. You choose you.',
    es: 'Eres suficiente. Importas. Te eliges a ti.',
  },
  victor: {
    en: "Your voice matters. Speak up. I've got your back.",
    es: 'Tu voz importa. Habla. Estoy contigo.',
  },
  cam: {
    en: 'Take a slow breath. The Power of Calm is yours.',
    es: 'Respira lento. El Poder de la Calma es tuyo.',
  },
};

/**
 * HeroOfTheDayCard — featured daily-rotating hero card on the youth dashboard.
 */
const HeroOfTheDayCard = ({ heroKey }) => {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || 'en').slice(0, 2);
  const hero = HEROES[heroKey];
  const tr = t(`heroes.${heroKey}`, { returnObjects: true });
  const mantra = DAILY_MANTRAS[heroKey][lang];

  return (
    <Card
      className="bs-glass mb-8 overflow-hidden border-0 hero-tile"
      data-testid={`hero-of-day-${heroKey}`}
    >
      <div className="grid sm:grid-cols-[200px_1fr] items-stretch">
        <div className={`${hero.imageBg} flex items-end justify-center p-3 min-h-[200px] sm:min-h-full`}>
          <img
            src={hero.image}
            alt={tr.name}
            className="max-h-48 sm:max-h-56 w-auto object-contain drop-shadow-2xl"
          />
        </div>
        <div className="p-6 flex flex-col justify-center">
          <span className="bs-chip mb-3 self-start">
            <Sparkles className="w-3.5 h-3.5" /> {t('heroLed.heroOfTheDay')}
          </span>
          <h2 className="bs-title text-2xl sm:text-3xl font-extrabold mb-1">{tr.name}</h2>
          <p className="bs-muted text-sm mb-3">{tr.pathDesc}</p>
          <p className="bs-amber italic font-semibold mb-4">"{mantra}"</p>
          <div className="flex flex-wrap gap-3">
            <Link to={`/activities?hero=${heroKey}`}>
              <button className="bs-cta" data-testid={`dashboard-featured-cta-${heroKey}`}>
                {t('heroLed.startWithHero', { hero: tr.name })}
                <ChevronRight className="w-4 h-4" />
              </button>
            </Link>
            <HeroNarrateButton
              hero={heroKey}
              text={mantra}
              label={t('heroLed.sayHi', { hero: tr.name })}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default HeroOfTheDayCard;
